import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { toast } from "react-toastify";
import { addCustomsHistory, fetchInvoiceForCustomsList } from "../../../api/po";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 190px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Customs = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Customs'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [approvalrows, setApprovalrows] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedIGMNo, setSelectedIGMNo] = useState('');
    const [selectedIGMDate, setSelectedIGMDate] = useState('');
    const [selectedDetentionDate, setSelectedDetentionDate] = useState('');
    const [selectedTelx, setSelectedTelx] = useState('');
    const [options, setOptions] = useState({
        duty_fees: '',
        duty_fees_error: '',
        duty_fees_no: '',
        duty_fees_no_error: ''
    });
    const [dutyFeesNoSet, setDutyFeesNoSet] = useState(null);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState("Successfully created the Custom");
    const [payload, setPayload] = useState(null);
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (value, input_name, index = null) => {
        if(index == null){
            let prev = {...options};
            prev[input_name] = value;
            setOptions(prev);
        } else {

            let rows = [...approvalrows];
            rows[index][input_name] = value; 

            if(input_name == 'received_qty'){
                rows[index]['remaining'] = Number(rows[index]['Quantity'])  - Number(rows[index]['received_qty']) ;
            }

            if(input_name == 'godown_required'){
                if(!dayjs().isBefore(dayjs(value))){
                    rows[index].bl_no_cfs = true;
                } else {
                    rows[index].bl_no_cfs = false;
                }
            }


            setApprovalrows(rows);
        }
        
    }

    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

        const columns = [
            {
                field: 'Sl_No', headerName: 'SL No.',
                // width: 100,
                sortable: false,
                resizable: false,
                flex: .5,
            },
            {
                field: 'Product_Name',
                headerName: 'Item Name',
                headerClassName: 'break-header',
                cellClassName: 'product_name_wrap',
                // width: 160,
                flex: 1,
                sortable: false,
                resizable: false,
                editable: false,
                renderCell: (params) => {
                    const productName = params.value;
                    return (
                        <div style={{ cursor: 'pointer' }}>
                            {productName}
                        </div>
                    );
                },
            },
            // {
            //     field: 'bl_no',
            //     headerName: 'Bl no.',
            //     headerClassName: 'table-header-background',
            //     sortable: false,
            //     headerAlign: 'center',
            //     cellClassName: 'center-aligndata',
            //     flex: 0.5,
            //     renderCell: (params) => {
            //         const isCFS = params.row.bl_no_cfs;
            //         return (
            //             <div style={{ cursor: 'pointer' }}>
            //                 {isCFS ? "CFS" : params.value}
            //             </div>
            //         );
            //     },
            //     //   width: 160,
            // },
            {
                field: 'Quantity',
                headerName: 'Quantity',
                headerClassName: 'table-header-background',
                sortable: false,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 0.5,
                //   width: 160,
            },
            {
                field: 'Unit_price',
                headerName: 'Unit Price',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                sortable: false,
                resizable: false,
                flex: .7,
                // width: 160,
            },
            {
                field: 'amount',
                headerName: 'Amount',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                sortable: false,
                resizable: false,
                flex: .7,
                // width: 160,
            },
            {
                    field: 'bl_no',
                    headerName: 'Bl no.',
                    headerClassName: 'table-header-background',
                    sortable: false,
                    headerAlign: 'center',
                    cellClassName: 'center-aligndata',
                    flex: 0.5,
                    renderCell: (params) => {
                        const isCFS = params.row.bl_no_cfs;
                        return (
                            <div style={{ cursor: 'pointer' }}>
                                {isCFS ? "CFS" : params.value}
                            </div>
                        );
                    },
                    //   width: 160,
                },
            {
                field: 'received_qty',
                headerName: 'Received QTY',
                headerClassName: 'break-header',
                sortable: false,
                resizable: false,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
                renderCell: (params) => {
                    const productName = params.value;
                    return (
                        <div className="mt-1" style={{ cursor: 'pointer' }}>
                            <TextField
                                className="invoice_field"
                                // id={`quantity-${index}`}
                                
                                variant="outlined"
                                type='number'
                                value={params.value}
                                
                                // disabled={row.productName == ''}
                                onChange={(event) => {
                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                    handleInputChange(event.target.value, 'received_qty', params.row.Sl_No -1)
                                    }
                                }}
                                sx={{ width: 100 }}
                            />
                        </div>
                    );
                },
                // width: 160,
            },
            {
                field: 'unit_price',
                headerName: 'Unit Price',
                headerClassName: 'break-header',
                sortable: false,
                resizable: false,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
                renderCell: (params) => {
                    return (
                        <div className="mt-1" style={{ cursor: 'pointer' }}>
                            <TextField
                                className="invoice_field"
                                // id={`quantity-${index}`}
                                
                                type='number'
                                variant="outlined"
                                value={params.value}
                                
                                // disabled={row.productName == ''}
                                onChange={(event) => {
                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                    handleInputChange(event.target.value, 'unit_price', params.row.Sl_No -1)
                                    }
                                }}
                                sx={{ width: 100 }}
                            />
                        </div>
                    );
                },
                // width: 160,
            },
            {
                field: 'remaining',
                headerName: 'Remaining',
                headerClassName: 'break-header',
                sortable: false,
                resizable: false,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
                renderCell: (params) => {
                    return (
                        <div className="mt-1 mb-1" style={{ cursor: 'pointer' }}>
                            <TextField
                                className="invoice_field"
                                // id={`quantity-${index}`}
                                
                                type='number'
                                variant="outlined"
                                value={params.value}
                                disabled
                                sx={{ width: 100 }}
                            />
                        </div>
                    );
                },
                // width: 160,
            },
            {
                field: 'godown_required',
                headerName: 'Godown Required',
                sortable: false,
                resizable: false,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
                renderCell: (params) => {
                    return (
                        <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            className='invoice_datepicker'
                            // label="Start Date"
                            disabled={params.row.received_qty >= params.row.Quantity}
                            value={dayjs(params.value)}
                            onChange={(event) => handleInputChange(event, 'godown_required', params.row.Sl_No -1)}
                        />
                    </LocalizationProvider>
                    </div>
                    );
                },
                // width: 160,
            },
        ];

        const fetchInvoiceForCustomsListFromBackend = async () => {
            try {
    
              const response = await fetchInvoiceForCustomsList();
                
              let formattedInvoices = response.data.invoiceList.map(el => ({
                id:el.id,
                invoice_number: el.invoice_number,
                label: el.invoice_number,
                telx:'Yes',
                IGM_Number: el.procurementIGM[0].igm_no,
                IGM_Date: dayjs(el.procurementIGM[0].igm_date).format('YYYY-MM-DD'),
                Detention_Date: dayjs(el.procurementIGM[0].detention_date).format('YYYY-MM-DD'),
                invoiceProducts: el.procurementInvoiceProducts,
                conversion_rate: el.conversion_rate,
                bl_no: el.bl_no
              }));

              setInvoiceList(formattedInvoices);

              setDutyFeesNoSet(new Set(response.data.setData));
    
            } catch (error) {
              toast.error("Error in fetching invoice data");
              console.log(error);
            }
          };
    
        // const approvalrows = [
        //     { id: 1, Sl_No: 1, item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000, received_qty:50,unit_price:20,container_no:"BL0987",amount_auto:8000, },
        //     { id: 2, Sl_No: 2,item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000, received_qty:50,unit_price:20,container_no:"BL0987",amount_auto:8000, },
        // ];
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        fetchInvoiceForCustomsListFromBackend();
    }, []);

    const addProductInvoiceRows = (result) => {
        if (result?.invoiceProducts.length > 0) {
            const formattedProducts = result.invoiceProducts.map((product, index) => ({
            id: product.id, // Assuming index + 1 as ID
            Sl_No: index + 1, // Serial Number
            bl_no: result.bl_no,
            bl_no_cfs: false,
            Product_No: product.item_no,
            Product_Name: product.item_name,
            Quantity: product.customs_pending_qty,
            Unit_price: product.displayed_unit_price,
            amount: product.displayed_unit_price * product.customs_pending_qty * result.conversion_rate,
            container_no: product.container_no,
            erp_po_product_id: product.erp_po_product_id,
            received_qty: '',
            unit_price: '',
            remaining:product.customs_pending_qty,
            godown_required: ''
            }));

            setApprovalrows(formattedProducts);
        }
      }

      const handleSubmit = async () => {
        try {
            let hasError = false;
            let newOptions = {...options};
            if(!newOptions.duty_fees){
                newOptions.duty_fees_error = 'Duty Fees is required!';
                hasError = true;
            }

            if(!newOptions.duty_fees_no){
                newOptions.duty_fees_no_error = 'Duty Fees number is required!';
                hasError = true;
            } else if(dutyFeesNoSet && dutyFeesNoSet.has(newOptions.duty_fees_no)){
                newOptions.duty_fees_no_error = 'Duty Fees number already exists!';
                hasError = true;
            }

            if(hasError){
                setOptions(newOptions);
                return;
            }


            /*
            {
             invoice_id: bigint;
                duty_fees: number;
                duty_fees_no: string;
                customs_product: {invoice_product_id: bigint, item_no: string, item_name: string, displayed_qty: number,displayed_unit_price: number, display_bl_no: string, received_qty: number, unit_price: number, remaining_qty: number,godown_require_date: Date }[]
            }

            */

            const data = {
                invoice_id: selectedInvoice.id,
                duty_fees: Number(options.duty_fees),
                duty_fees_no: options.duty_fees_no,
                customs_product: approvalrows.map(el => ({
                    invoice_product_id: el.id, 
                    item_no: el.Product_No, 
                    item_name: el.Product_Name, 
                    displayed_qty: el.Quantity,
                    displayed_unit_price: el.Unit_price, 
                    display_bl_no: el.bl_no, 
                    received_qty: Number(el.received_qty), 
                    unit_price: Number(el.unit_price), 
                    remaining_qty: el.remaining,
                    container_no: el.container_no,
                    erp_po_product_id: el.erp_po_product_id,
                    godown_require_date: el.godown_required ? dayjs(el.godown_required).format('YYYY-MM-DD') : null
                }))
            };

            data.customs_product = data.customs_product.filter(el => el.received_qty > 0 && el.unit_price > 0);

            if(data.customs_product.length == 0){
                toast.error("Fill all the required fields!");
                return;
            }

            setPayload(data);
            setSubmitModalOpen(true);

            // const response = await addCustomsHistory(payload);
            
            // if(response.statusCode == 200){
            //     setMessage(`Successfully created the Custom`);
            //     setIsOpenSweetAlert(true);
            //     setSelectedInvoice(null);
            //     fetchInvoiceForCustomsListFromBackend();
            // }


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }

    const submitRequisition = async () => {
        try {
            setIsLoading(true)

            
            const response = await addCustomsHistory(payload);

            
            if(response.statusCode == 200){
                setSubmitModalOpen(false);
    
                setMessage(`Successfully created the Custom`);

        
                setIsOpenSweetAlert(true);
                setSelectedInvoice(null);
                setPayload(null);

                fetchInvoiceForCustomsListFromBackend();

            }
        }
        catch (e){
            console.log(e)
            toast.error('Error in creating Purchase invoice')
        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    };

    useEffect(() => {
        setOptions({
            duty_fees: '',
            duty_fees_error: '',
            duty_fees_no: '',
            duty_fees_no_error: ''
        });
        setSelectedIGMNo('');
        setSelectedIGMDate('');
        setSelectedTelx('');
        setSelectedDetentionDate('');
        setApprovalrows([]);
        if(selectedInvoice){
            setSelectedIGMNo(selectedInvoice.IGM_Number);
            setSelectedIGMDate(selectedInvoice.IGM_Date);
            setSelectedTelx(selectedInvoice.telx);
            setSelectedDetentionDate(selectedInvoice.Detention_Date);
            let result = invoiceList.find(el => el.id == selectedInvoice?.id);
            addProductInvoiceRows(result);
        }
    }, [selectedInvoice, invoiceList]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center justify-content-between'>
                                            <div className="d-flex align-items-center gap-2">
                                                <p className='mb-0 me-2 requisition_type_text'>
                                                    {/* Invoice No */}
                                                    Customs
                                                </p>
                                                <div>
                                                    <Autocomplete
                                                        className="invoice_autofield"
                                                        // id={`product-category`}
                                                        sx={{ width: 296 }}
                                                        options={invoiceList}
                                                        value={selectedInvoice}
                                                        onChange={(e, value) => setSelectedInvoice(value)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Invoice No"
                                                            />
                                                        )}
                                                    />

                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-end mt-2">
                                <button className="assign_vendor" disabled={!selectedInvoice} onClick={handleSubmit}>Submit</button>
                           </div>
                                        {/* <div className="d-flex align-items-center">
                                            <button className="assign_vendor" disabled={!selectedInvoice} onClick={handleSubmit}>Submit</button>
                                        </div> */}
                                    </div>
                                    <hr className='mb-2 mt-1 ms-1 me-1'></hr>
                                    <div>
                                        <div className="d-flex align-items-center gap-3 justify-content-between mt-2">
                                            <div>
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>IGM No:</p>
                                                <p className="mb-0" style={{color:'#2B2A29', fontSize:'14px', fontWeight:'400'}}>{selectedIGMNo}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid #E1E1E1', height: '45px'}}></div>
                                            <div>
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>Telx Status:</p>
                                                <p className="mb-0" style={{color:'#2B2A29', fontSize:'14px', fontWeight:'400'}}>{selectedTelx}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid #E1E1E1', height: '45px'}}></div>
                                            <div>
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>IGM Date:</p>
                                                <p className="mb-0" style={{color:'#2B2A29', fontSize:'14px', fontWeight:'400'}}>{selectedIGMDate}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid #E1E1E1', height: '45px'}}></div>
                                            <div>
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>Detention Date:</p>
                                                <p className="mb-0" style={{color:'#2B2A29', fontSize:'14px', fontWeight:'400'}}>{selectedDetentionDate}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid #E1E1E1', height: '45px'}}></div>
                                            <div>
                                                <div className="mt-1" style={{ cursor: 'pointer' }}>
                                                    <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>Duty Fees:</p>
                                                <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Duty Fees"
                                                variant="outlined"
                                                value={options.duty_fees}
                                                type="number"
                                                // disabled={row.productName == ''}
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){
                                                    handleInputChange(event.target.value, 'duty_fees')

                                                    }
                                                }}
                                                sx={{ width: 210 }}
                                            />
                                            {options.duty_fees_error && <span className="error-message" style={{ color: 'red' }}>{options.duty_fees_error}</span>}

                                                </div>
                                            </div>
                                            <div>
                                                <div className="mt-1" style={{ cursor: 'pointer' }}>
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'14px', fontWeight:'400'}}>Duty Fees No.</p>
                                                <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Duty Fees No"
                                                variant="outlined"
                                                value={options.duty_fees_no}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'duty_fees_no')}
                                                sx={{ width: 210 }}
                                            />
                                            {options.duty_fees_no_error && <span className="error-message" style={{ color: 'red' }}>{options.duty_fees_no_error}</span>}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            {/* <div>
                                <h4 className="mb-0 requisition_text">Customs List</h4>
                            </div> */}
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '10px', marginTop: '8px' }}>
                                <DataGrid
                                   autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                            {/* <div className="d-flex align-items-center justify-content-end mt-2">
                                <button className="assign_vendor" disabled={!selectedInvoice} onClick={handleSubmit}>Submit</button>
                           </div> */}
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Custom?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product</th>

                                            <th>Total Quantity</th>
                                            <th>Rec. Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Remaining</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        {payload?.customs_product.map((row, index) => (
                                            <tr key={row.value}>
                                                <td>{++index}</td>
                                                <td>{row.item_name}</td>
                                                <td>{row.displayed_qty}</td>
                                                <td>{row.received_qty}</td>
                                                <td>{row.unit_price}</td>
                                                <td>{row.remaining_qty}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="2">Total :</th>
                                            <td>{payload?.customs_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.displayed_qty;
                                                }, 0)}</td>
                                            <td>{payload?.customs_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.customs_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.customs_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.remaining_qty;
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert 
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default Customs;
